<template>
    <v-container>

        <v-flex>
            <v-row>
                <h1 class="page-title">Log In</h1>
                <v-spacer class="line"></v-spacer>
                <hr>
<!--                <span class="auth-type-question">Haven't got an account?</span>-->
<!--                <v-btn depressed-->
<!--                       color="primary"-->
<!--                       to="/registration"-->
<!--                >-->
<!--                    <v-icon left>mdi-account-plus</v-icon>-->
<!--                    Register-->
<!--                </v-btn>-->
                <v-tabs v-model="tab_login_panel" right>
                    <v-tab>Business</v-tab>
                    <v-tab>Admin</v-tab>
                    <!-- <v-tab>Driver</v-tab> -->
                </v-tabs>
            </v-row>
        </v-flex>

        <v-card>
            <v-container>
                <v-form ref="form"
                        v-model="valid"
                        validation>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card-text>
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="email"
                                        label="Email"
                                        type="email"
                                        v-model="email"
                                        :rules="emailRules"
                                ></v-text-field>
                                <v-text-field
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        name="password"
                                        label="Password"
                                        v-model="password"
                                        :rules="passwordRules"
                                        :counter="12"
                                ></v-text-field>
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        depressed
                                        class="primary"
                                        @click="onSubmit"
                                        :loading="localLoading"
                                        :disabled="!valid || localLoading"
                                >
                                    <v-icon left>mdi-check</v-icon>
                                    Log In
                                </v-btn>
                                <v-btn
                                        depressed
                                        class="warning"
                                        @click="onCancel"
                                        :loading="localLoading"
                                        :disabled="localLoading"
                                >
                                    <v-icon left>mdi-cancel</v-icon>
                                    Cancel
                                </v-btn>
                            </v-card-actions>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "LogIn",
        mounted: function () {
            if (localStorage.getItem("user")) {
                let user = JSON.parse(localStorage.getItem("user"));
                if(user.role == 'restaurant') {
                    this.$router.push('/schedulerestaurant');
                } else { // user.role == 10 || user.role == 20
                    this.$router.push('/schedule');
                }
            }
        },
        data() {
            return {
                user: '',
                showPassword: false,
                email: '',
                password: '',
                valid: false,
                localLoading: false,
                messages: {
                    incorrect_login: "Incorrect logins - please try again!",
                },
                emailRules: [
                    v => !!v || 'Please enter your e-mail',
                    v => /.+@.+/.test(v) || 'Must be valid e-mail'
                ],
                passwordRules: [
                    v => !!v || 'Please enter your password',
                    v => (v && v.length >= 6) || 'Password should be at least six symbols long'
                ],
                tab_login_panel: 0
            }
        },

        methods: {
            onCancel() {
                this.email = ''
                this.password = ''
            },
            onSubmit() {
                if (this.$refs.form.validate()) {
                    this.localLoading = true;
                    const user = {
                        email: this.email,
                        password: this.password
                    }

                    switch(this.$data.tab_login_panel) {
                        case 0:
                            axios.post(`${this.appConfig.app_url}/api/auth/login/restaurant`, user)
                                .then(res => {
                                    let result = res.data.restaurant;

                                    this.user = {
                                        id: result.id,
                                        firstName: result.name,
                                        lastName: '',
                                        email: result.email,
                                        restaurantsWorksFor: [],
                                        access_token:res.data.access_token,
                                        role: 'restaurant',
                                        restaurants: result.restaurants,
                                    };
                                    localStorage.setItem("user", JSON.stringify(this.user));
                                })
                                .then(() => {
                                    this.$router.go('/schedulerestaurant');
                                })
                                .catch(error => {
                                    let errors = error.response;

                                    if (error.response.status && error.response.status === 401) {
                                        errors = this.messages.incorrect_login;
                                    }

                                    this.$store.dispatch('setError', errors);
                                }).finally(() => {
                                    this.localLoading = false;
                                })
                            break;
                        case 1:
                            axios.post(`${this.appConfig.app_url}/api/auth/login`, user)
                                .then(res => {
                                    let result = res.data.user;

                                    this.user = {
                                        id: result.id,
                                        firstName: result.first_name,
                                        lastName: result.last_name,
                                        email: result.email,
                                        restaurantsWorksFor: [],
                                        access_token:res.data.access_token,
                                        role:result.role, // admin
                                        restaurants: []
                                    };
                                    localStorage.setItem("user", JSON.stringify(this.user));
                                })
                                .then(() => {
                                    this.$router.go('/schedule');
                                })
                                .catch(error => {
                                        let errors = error.response;

                                        if (error.response.status && error.response.status === 401) {
                                            errors = this.messages.incorrect_login;
                                        }

                                        this.$store.dispatch('setError', errors);
                                    })
                                .finally(() => {
                                    this.localLoading = false;
                                })
                            break;
                        case 2:
                            axios.post(`${this.appConfig.app_url}/api/auth/login/driver`, user)
                                .then(res => {
                                    let result = res.data.driver;

                                    this.user = {
                                        id: result.id,
                                        firstName: result.first_name,
                                        lastName: result.last_name,
                                        email: result.email,
                                        restaurantsWorksFor: [],
                                        access_token:res.data.access_token,
                                        role: 'driver',
                                        restaurants: []
                                    };
                                    localStorage.setItem("user", JSON.stringify(this.user));
                                })
                                .then(() => {
                                    this.$router.go('/newsfeed');
                                })
                                .catch(error => {
                                    let errors = error.response;

                                    if (error.response.status && error.response.status === 401) {
                                        errors = this.messages.incorrect_login;
                                    }

                                    this.$store.dispatch('setError', errors);
                                })
                                .finally(() => {
                                    this.localLoading = false;
                                })
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>